import Alert from 'component/base/Alert';
import {
  composeValidators,
  email,
  required,
} from 'component/base/Form/Validation';
import { Flex } from 'component/base/Grid';
import { Button } from 'component/ui/Button';
import PasswordInputField from 'component/ui/FormFields/PasswordInput';
import TextInputField from 'component/ui/FormFields/TextInput';
import { Design, FlexAlignment, Intent } from 'enums';
import { TestSelector } from 'enums/tests';
import React from 'react';
import { Field, Form, FormRenderProps } from 'react-final-form';

import { FormElement } from './styles';

interface LoginFormValues {
  email: string;
  password: string;
}

const renderForm = ({
  submitError,
  handleSubmit,
  submitting,
  valid,
}: FormRenderProps<LoginFormValues>) => {
  return (
    <FormElement onSubmit={handleSubmit}>
      {!submitting && submitError && (
        <Alert
          data-test={TestSelector.AUTHENTICATION_SIGNIN_EMAIL_PASSWORD_ERROR}
        >
          {submitError}
        </Alert>
      )}

      <Field
        component={TextInputField}
        id="email"
        name="email"
        type="email"
        autoComplete="username email"
        label="Work email"
        design={Design.LARGE}
        disabled={submitting}
        validate={composeValidators(required, email)}
      />

      <Field
        component={PasswordInputField}
        id="password"
        name="password"
        type="password"
        autoComplete="current-password"
        label="Password"
        design={Design.LARGE}
        disabled={submitting}
        validate={required}
        showResetLink
      />

      <Flex mt={1} justifyContent={FlexAlignment.CENTER}>
        <Button
          data-test={TestSelector.AUTHENTICATION_EMAIL_PASSWORD_BUTTON}
          type="submit"
          disabled={(!valid && !submitError) || submitting}
          submitting={submitting}
          design={Design.LARGE}
          intent={Intent.QUATERNARY}
          block
        >
          Sign in
        </Button>
      </Flex>
    </FormElement>
  );
};

interface LoginFormProps {
  onSubmit: (values: LoginFormValues) => Promise<{
    'FINAL_FORM/form-error': string;
  } | null>;
}

const LoginForm = ({ onSubmit }: LoginFormProps) => {
  return <Form onSubmit={onSubmit} render={renderForm} />;
};

export default LoginForm;
